export const SHOW_MESSAGE = 'messages/SHOW_MESSAGE'
export const HIDE_MESSAGE = 'messages/HIDE_MESSAGE'
export const SET_WEBSOCKET = 'messages/SET_WEBSOCKET'
export const WEDSOCKET_SEND = 'messages/WEDSOCKET_SEND'
export const MESSAGES_DATA = 'messages/MESSAGES_DATA'



// WEBPACK FOOTER //
// ./src/vuex/modules/messages/types.js